import api from '@/lib/api'

export interface ApiVersion {
  service: string
  version: string
  commit: string
  build_date: string
}

export const getApiVersion = () =>
  api.get<{ success: true; data: ApiVersion }>('/version').then(r => r.data.data)
